/**
 * @generated SignedSource<<0c216f59d30aa6e5611369782665a16f>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type Answers_question$data = {
  readonly answers: ReadonlyArray<{
    readonly author: {
      readonly " $fragmentSpreads": FragmentRefs<"Author_author">;
    } | null;
    readonly formattedCreatedDate: string | null;
    readonly serviceId: string;
    readonly text: string | null;
  } | null> | null;
  readonly " $fragmentType": "Answers_question";
};
export type Answers_question$key = {
  readonly " $data"?: Answers_question$data;
  readonly " $fragmentSpreads": FragmentRefs<"Answers_question">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "Answers_question",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "AnswerType",
      "kind": "LinkedField",
      "name": "answers",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "serviceId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "text",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "formattedCreatedDate",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Seller",
          "kind": "LinkedField",
          "name": "author",
          "plural": false,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "Author_author"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "QuestionType",
  "abstractKey": null
};

(node as any).hash = "3a28d0490c5e2766ef019b7f1707e9ca";

export default node;
